// extracted by mini-css-extract-plugin
export default {"error404":"style--error404--47df2e","logo":"style--logo--69c4f6","textblock":"style--textblock--4b94ca"};